import { Component } from '@angular/core';

@Component({
  selector: 'app-rrhh-confirm-reactivate-member',
  templateUrl: './rrhh-confirm-reactivate-member.component.html',
  styleUrls: ['./rrhh-confirm-reactivate-member.component.scss'],
})
export class RrhhConfirmReactivateMemberComponent {}
